import { CacheService } from '@/utils/cacheService/cache.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { FilterList, Person, UserDataList } from '../../interfaces/person';
import { ParseRutPipe } from '../../pipes/parse-rut.pipe';


@Injectable({
  providedIn: 'root',
})
export class DriverService {

  constructor(
    private http: HttpClient,
    private cacheService: CacheService,
  ) { }

  getFilteredList(filterText: string): Observable<FilterList> {
    if (!filterText) {
      return of([]);
    }
    return this.http.get<UserDataList>(`Driver/DriversSearch/${filterText}`)
      .pipe(
        map<UserDataList, FilterList>(
          (array) => this.getParsedList(array),
        ),
      );
  }

  getActiveMineLicenseFilteredList(filterText: string): Observable<FilterList> {
    if (!filterText) {
      return of([]);
    }
    return this.http.get<UserDataList>(`Driver/DriversSearchMineLicense/${filterText}`)
      .pipe(
        map<UserDataList, FilterList>(
          (array) => this.getParsedList(array),
        ),
      );
  }

  getDataByRutDv(filterText: string): Observable<Person> {
    return this.http.get<UserDataList>(`Driver/DriversSearch/${filterText}`)
      .pipe(
        map<UserDataList, { id: number }>(
          (array) => array.map((userData) => ({
            id: userData.id,
          }))[0],
        ),
        switchMap(({ id }) => this.getDataById(id)),
      );
  }

  // Person data should not change
  getDataById(id: number): Observable<Person> {
    const source$ = this.http.get<Person>(`Driver/DriversSearchById/${id}`);
    return this.cacheService.save<Person>(`DriversSearchById${id}`, 24 * 60, source$);
  }

  getParsedList(array: UserDataList): FilterList {
    const parseRutPipe = new ParseRutPipe();
    const rutOrPassport = (rutDv: string, passport: string) => (rutDv ? parseRutPipe.transform(rutDv) : passport);
    return array.map((userData) => ({
      id: userData.id.toString(),
      value: `${userData.fullName} - ${userData.email} - ${rutOrPassport(userData.rutDv, userData.passport)}`,
      mdmid: userData.mdmid,
      email: userData.email,
    })).reduce<FilterList>((acc, x) => {
      const findedIndex = acc.findIndex((y) => x.id === y.id);
      if (findedIndex < 0) {
        acc.push(x);
      }
      return acc;
    }, []);
  }

}
